import { useState, useCallback } from 'react';

import { usePlayerManagerContext } from '@/scenarios/legacy-player/components/PlayerManager/parts/context';
import { useOnFullscreenChange } from '@/scenarios/legacy-player/components/PlayerSkin/parts/Layout/hooks/useOnFullscreenChange';

export const useFullscreen: () => { isFullscreen: boolean; toggleFullscreen: () => void } = () => {
    const [isFullscreen, setIsFullscreen] = useState(false);
    const { toggleFullscreen } = usePlayerManagerContext();

    const onFullscreenChange = useCallback((isFullscreen: boolean) => {
        setIsFullscreen(isFullscreen);
    }, []);

    useOnFullscreenChange(onFullscreenChange, { withInitialCall: true });

    return {
        isFullscreen,
        toggleFullscreen,
    };
};
